import { ApolloCache, FetchResult } from "@apollo/client";
import {
	clearTimelineQueryCache,
	StudentNote,
	StudentNoteCreateInput,
	StudentNoteCreateMutation,
	StudentNoteDeleteMutation,
	StudentNoteUpdateInput,
	StudentNoteUpdateMutation,
} from "../../../Utilities";
import * as StudentNoteFormValues from "./form-values";

export function customUpdateCacheForCreate(
	_input: StudentNoteCreateInput,
	cache: ApolloCache<any>,
	_result: Omit<FetchResult<StudentNoteCreateMutation, Record<string, any>, Record<string, any>>, "context">,
) {
	clearTimelineQueryCache(cache);
}

export function customUpdateCacheForUpdate<
	K extends keyof StudentNoteFormValues.Detail = keyof StudentNoteFormValues.Detail,
>(
	input: StudentNoteUpdateInput,
	_initialFormValues: StudentNoteFormValues.DetailSubset<K>,
	cache: ApolloCache<any>,
	_result: Omit<FetchResult<StudentNoteUpdateMutation, Record<string, any>, Record<string, any>>, "context">,
) {
	if (input.isPinned !== undefined) {
		cache.evict({ id: "ROOT_QUERY", fieldName: "studentNoteConnection" });
	}
}

export function customUpdateCacheForDelete(
	_id: StudentNote["id"],
	_cache: ApolloCache<any>,
	_result: Omit<FetchResult<StudentNoteDeleteMutation, Record<string, any>, Record<string, any>>, "context">,
) {}
